import { instantWinEndpoints } from './InstantWinEndpoints';
const CAMPAIGNID = process.env.REACT_APP_CAMPAIGN_ID;
const reqHeaders = new Headers();
reqHeaders.append('Content-Type', 'application/json');
reqHeaders.append('campaignid', CAMPAIGNID);

class InstantWinApi {
    async registerVenue(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.register, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkUnique(id) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(`${instantWinEndpoints.unique}${id}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getIWNearbyLocations(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.locations, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkDelay(id) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(`${instantWinEndpoints.delay}${id}`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getDistanceBetween(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.distance, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async swipeUniqueCode(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.swipe, requestOptions);
            let resp = await respJson.json();
            return resp;
        } catch (error) {
            return error.message;
        }
    }

    async redeemUniqueCode(formData) {
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.redeem, requestOptions);
            let resp = await respJson.json();
            return resp;
        } catch (error) {
            return error.message;
        }
    }

    async setSelectedVenue(uniqueCode, venueId, serve) {
        const formData = {
            code: uniqueCode,
            venueId: venueId,
            serve: serve,
        };
        const requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(instantWinEndpoints.venueSelect, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async getSelectedVenue(venueId) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(
                `${instantWinEndpoints.selectedVenue}${venueId}`,
                requestOptions
            );
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async activateInstant(userId, payload) {
        const requestOptions = {
            method: 'PUT',
            headers: reqHeaders,
            body: JSON.stringify(payload),
        };
        try {
            const respJson = await fetch(
                `${instantWinEndpoints.instant}/${userId}`,
                requestOptions
            );
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkInstant(userId) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(
                `${instantWinEndpoints.instant}/${userId}`,
                requestOptions
            );
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async claimInstant(formData) {
        const requestOptions = {
            method: 'PUT',
            headers: reqHeaders,
            body: JSON.stringify(formData),
        };
        try {
            const respJson = await fetch(`${instantWinEndpoints.instant}/claim`, requestOptions);
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }

    async checkRegistration(id) {
        const requestOptions = {
            method: 'GET',
            headers: reqHeaders,
        };
        try {
            const respJson = await fetch(
                `${instantWinEndpoints.registerCheck}${id}`,
                requestOptions
            );
            return await respJson.json();
        } catch (error) {
            return error.message;
        }
    }
}

export default new InstantWinApi();
